<template functional>
  <div class="zapper-talkto-overlay">
    <div class="overlay" :class="{ selected }"></div>
    <slot> </slot>
  </div>
</template>
<script>
export default {
  props: {
    selected: Boolean,
  },
};
</script>
<style lang="scss">
.zapper-talkto-overlay {
  position: relative;
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 3px solid;
    border-color: transparent;
    border-radius: 10px;
    margin: 2px;

    &.selected {
      border-color: var(--statusNotice);
    }
  }
}
</style>